module.exports = __webpack_public_path__ + "img/logo-dinapsis-aplicaciones.229ddc60.svg";